document.addEventListener('DOMContentLoaded', () => {
    const videoWrappers = document.querySelectorAll('[data-inline-video]');

    videoWrappers.forEach(wrapper => {
        const videoId = wrapper.dataset.videoId;

        wrapper.dataset.originalContent = wrapper.innerHTML;

        wrapper.addEventListener('click', () => {
            if (wrapper.classList.contains('pf-video-is-playing')) return;
            wrapper.classList.add('pf-video-is-playing');

            const carousel = wrapper.closest('.pf-video-carousel.owl-carousel');
            if (carousel) {
                jQuery(carousel).trigger('stop.owl.autoplay');
            }

            const iframe = document.createElement('iframe');
            iframe.setAttribute('width', '560');
            iframe.setAttribute('height', '315');
            iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`);
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; encrypted-media');
            iframe.setAttribute('allowfullscreen', '');
            wrapper.innerHTML = ''; // Clear existing content
            wrapper.appendChild(iframe);
        });
    });
});